// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2AXrL","productName":"Table_productName__2BT4o"};